import {
  collection,
  doc,
  getDocs,
  updateDoc,
  deleteDoc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";
import { createUserWithEmailAndPassword, AuthErrorCodes } from "firebase/auth";

export class UsersController {
  static TABLE_NAME = TableName.USERS;

  static getAll = ({ resolve, reject }) => {
    let errorMessage =
      "Unable to get all the users details.\nPlease contact administrator for assistance.";
    getDocs(collection(db, this.TABLE_NAME))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static add = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to create new users details.\nPlease contact administrator for assistance.";
    createUserWithEmailAndPassword(auth, parameters.email, parameters.password)
      .then((userCredential) => {
        getDoc(doc(db, this.TABLE_NAME, userCredential.user.uid))
          .then((data) => {
            if (!data.exists()) {
              setDoc(
                doc(db, this.TABLE_NAME, userCredential.user.uid),
                parameters
              )
                .then(() => {
                  resolve("New users details added to firebase successfully.");
                })
                .catch((error) => {
                  reject(
                    this.errorHandling({
                      errorMessage: errorMessage,
                      error: error,
                    })
                  );
                });
            } else {
              reject("This email has been registered.");
            }
          })
          .catch((error) => {
            reject(
              this.errorHandling({ errorMessage: errorMessage, error: error })
            );
          });
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static update = ({ parameters, resolve, reject }) => {
    let errorMessage =
      "Unable to update the selected users details.\nPlease contact administrator for assistance.";
    updateDoc(doc(db, this.TABLE_NAME, parameters.id), parameters)
      .then(() => {
        resolve("Users details updated to firebase successfully.");
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static deleteAll = ({ idList, resolve, reject }) => {
    let errorMessage =
      "Unable to delete all the users details.\nPlease contact administrator for assistance.";
    const deletePromises = idList.map((id) => {
      return deleteDoc(doc(db, this.TABLE_NAME, id)).catch((error) => {
        console.debug(error.message);
        throw error;
      });
    });
    Promise.all(deletePromises)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case AuthErrorCodes.EMAIL_EXISTS:
        errorMessage = "This email address is already in use.";
        break;
      case AuthErrorCodes.INVALID_EMAIL:
        errorMessage =
          "Email address provided is invalid.\nPlease use the correct email format or use a different email address.";
        break;
      case AuthErrorCodes.WEAK_PASSWORD:
        errorMessage = "Please provide a stronger password.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
